import React, { useEffect, useState } from 'react';
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import Table from '@cloudscape-design/components/table';
import { apiJson } from '../utils/api';

interface AdminUser {
  user_id: string;
  email?: string;
  display_name?: string;
  role?: string;
  owner_verified?: boolean;
  created_at?: string;
}

const UsersPage: React.FC = () => {
  const [items, setItems] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiJson<{ items: AdminUser[] }>('/admin/users?pageSize=50')
      .then((d) => setItems(d.items))
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ContentLayout header={<Header variant="h1">Users</Header>}>
      {error && (
        <Alert type="error" header="Failed to load users">
          {error}
        </Alert>
      )}
      <Table
        loading={loading}
        loadingText="Loading users"
        items={items}
        columnDefinitions={[
          { id: 'email', header: 'Email', cell: (u) => u.email ?? '—' },
          { id: 'name', header: 'Name', cell: (u) => u.display_name ?? '—' },
          { id: 'role', header: 'Role', cell: (u) => u.role ?? 'User' },
          { id: 'owner', header: 'Owner verified', cell: (u) => (u.owner_verified ? 'Yes' : 'No') },
          { id: 'created', header: 'Joined', cell: (u) => u.created_at?.slice(0, 10) ?? '—' },
        ]}
        empty={<Box textAlign="center">No users yet.</Box>}
        variant="full-page"
        header={<Header counter={`(${items.length})`}>All users</Header>}
      />
    </ContentLayout>
  );
};

export default UsersPage;
